import { makeAutoObservable } from 'mobx';

/**
 * Tracks in-flight non-periodic API calls so the files-list refresher
 * can stay on the fast interval while uploads or mutations are running.
 */
class ApiActivityTracker {
    private count = 0;

    constructor() {
        makeAutoObservable(this);
    }

    get isActive(): boolean {
        return this.count > 0;
    }

    markStart(): void {
        this.count += 1;
    }

    markEnd(): void {
        if (this.count > 0) {
            this.count -= 1;
        }
    }
}

const apiActivityTracker = new ApiActivityTracker();

export default apiActivityTracker;
